import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Alert,
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import periodosLetivos, {
  PeriodosLetivosRequest,
} from "../../api/periodosLetivos";
import { errorToString } from "../../helpers/funcoes";
import { Titulo } from "../Titulo";

function toInputDate(value?: string) {
  if (!value) return "";
  return value.length >= 10 ? value.slice(0, 10) : value;
}

function toIsoDate(value: string, start: boolean) {
  if (!value) return "";
  const date = moment(value, "YYYY-MM-DD", true);
  return date.isValid()
    ? (start ? date.startOf("day") : date.endOf("day")).toISOString(true)
    : "";
}

export function PeriodosLetivosForm() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string>();

  const [nome, setNome] = useState("");
  const [startAt, setStartAt] = useState("");
  const [endAt, setEndAt] = useState("");

  useEffect(() => {
    if (id) {
      setLoading(true);
      periodosLetivos
        .read(id)
        .then((res) => {
          setNome(res.nome);
          setStartAt(toInputDate(res.startAt));
          setEndAt(toInputDate(res.endAt));
        })
        .catch((err) => setError(errorToString(err)))
        .finally(() => setLoading(false));
    }
  }, [id]);

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setSaving(true);
    setError(undefined);

    const payload: PeriodosLetivosRequest = {
      nome,
      startAt: toIsoDate(startAt, true),
      endAt: toIsoDate(endAt, false),
    };

    (id ? periodosLetivos.update(id, payload) : periodosLetivos.create(payload))
      .then(() => navigate("/periodos-letivos"))
      .catch((err) => setError(errorToString(err)))
      .finally(() => setSaving(false));
  };

  if (loading) {
    return (
      <div className="text-center">
        <Spinner />
      </div>
    );
  }

  return (
    <Form onSubmit={onSubmit}>
      <Titulo text={`${id ? "Editar" : "Adicionar"} Período letivo`} />
      {error && (
        <Alert color="danger" data-cy="alert">
          {error}
        </Alert>
      )}
      <FormGroup row>
        <Label for="txtNome" sm={2}>
          Nome:
        </Label>
        <Col sm={10}>
          <Input
            id="txtNome"
            data-cy="nome"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            required
            disabled={saving}
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label for="dtStartAt" sm={2}>
          Início:
        </Label>
        <Col sm={4}>
          <Input
            id="dtStartAt"
            data-cy="startAt"
            type="date"
            value={startAt}
            onChange={(e) => setStartAt(e.target.value)}
            required
            disabled={saving}
          />
        </Col>
        <Label for="dtEndAt" sm={2} className="text-end">
          Fim:
        </Label>
        <Col sm={4}>
          <Input
            id="dtEndAt"
            data-cy="endAt"
            type="date"
            value={endAt}
            min={startAt || undefined}
            onChange={(e) => setEndAt(e.target.value)}
            required
            disabled={saving}
          />
        </Col>
      </FormGroup>
      <Row>
        <Col sm={6}>{saving && <Spinner />}</Col>
        <Col sm={6} className="text-end">
          <Button type="submit" disabled={saving}>
            Salvar
          </Button>
        </Col>
      </Row>
    </Form>
  );
}
